import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { TransportationEntryService } from 'src/app/service/document-control/transportation-entry.service';
import { ExportStateService } from 'src/app/service/export-state.service';

@Component({
    selector: 'app-transportation-entry-details',
    templateUrl: './transportation-entry-details.component.html',
    styleUrls: ['./transportation-entry-details.component.scss'],
    standalone: false
})
export class TransportationEntryDetailsComponent implements OnInit {

  gridApi: any;
  successMessage: string;
  errorMessage: string;
  columnDefs = [];
  displayRowData = [];
  currentPageNo: number;
  currentPageBoolean: boolean = false;
  totalPage: number;
  currentPageForTotalPage: number;
  isLastPageFound: boolean;
  rowCount: number;
  defaultColDef: {};
  gridOptions
  icons: {};
  userID: number;
  context: {};
  shipmentTypesDropdown = [];
  te_number;
  isAccessible = false;
  paginationPageSize: number = 20;
	setPagination = 'true';
  @ViewChild('agGrid', { static: true }) agGrid
	dynamicHeight: number;
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 20;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
		{value: 20 , selected : true},
		{value: 50 , selected : false},
    {value: 'ALL' , selected : false},
	]
  constructor(private readonly constants: Constants, private readonly router: Router, private readonly location: Location, private readonly exportStateService: ExportStateService,
    private readonly transportationEntryService: TransportationEntryService, private readonly ngxUiLoaderService: NgxUiLoaderService) {
    this.context = {
      componentParent: this
    };
    this.defaultColDef = {
      suppressMovable: true, wrapText: true
    }
  }

  ngOnInit(): void {
    this.dynamicHeight = 0.665 * (window.innerHeight) - 55;
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.te_number = JSON.parse(localStorage.getItem('transportation-entry-details'));
    this.columnDefs = [
      {
        headerName: "SUPPLIER", field: "te_supplier", width: 100,
      },
      {
        headerName: "SHIP DATE", field: "shipmentDate", width: 100,
      },
      {
        headerName: "INVOICE#", field: "invoiceNo", width: 100,
      },
      {
        headerName: "TYPE", field: "freightType", width: 100,
      },
      {
        headerName: "SETS", field: "te_sets", width: 100,
      },
      {
        headerName: "PALLETS", field: "te_pallets", width: 100,
      },
      {
        headerName: "GROSS KG", field: "grossWeight", width: 100,
      }, {
        headerName: "NET KG", field: "netWeight", width: 100,
      },
      {
        headerName: "TARE KG", field: "tareWeight", width: 100,
      }, {
        headerName: "PART $", field: "partValue", width: 100,
      },
      {
        headerName: "214/BA#", field: "te_214", width: 100,
      }, {
        headerName: "IT BOND", field: "te_it", width: 100,
      }];
    // this.checkRoles();
    this.refreshData();
  }
  async checkRoles() {
    await this.exportStateService.getRoles();
    const roles = this.exportStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_NAMCPlanner60EXP)) {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // } // Commented for APM
  }

  sizeToFit() { this.gridApi.sizeColumnsToFit(); }

	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
      {this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length)); this.updatePaginationDetails();}
    else
     { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails();}
  }

  defaultRowData() {
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
  }

  getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event:any) {
		this.cPage = 1;
		event.target.value === 'ALL' ? this.gridApi?.setGridOption('paginationPageSize', this.totalRecords) : this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}

  refreshData(): void {
    if (this.te_number) {
      this.displayRowData = []
      this.gridApi?.setGridOption('rowData', this.displayRowData);
      this.rowCount = this.displayRowData.length;
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.transportationEntryService.loadDataTransportationEntryDetails(this.te_number).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response && response.length > 0) {
            this.displayRowData = response
            this.gridApi?.setGridOption('rowData', this.displayRowData);
            this.rowCount = this.displayRowData.length;
            if (this.displayRowData.length) {
              this.totalRecords = this.displayRowData.length;
              this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
              this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
              this.sRecord = 1
              this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
              if (this.cPage > this.tPage) {
                this.cPage = 1;
              }
            }
          } else {
            this.errorMessage = "Currently there are no details available for the selected TE Number.";
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTimeShort);
          }
        },
        _error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTimeShort);
        }
      );
    } else {
      this.errorMessage = "Error with TE Number.";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);
    }
  }

  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }
  openRouteLevel(route) {
    this.router.navigate([`${route}`]);
  }
  goBack() {
    this.location.back();
  }

}
